var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceptActIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40001 14.652V7.23798C4.40001 5.24017 4.40001 4.24127 5.01508 3.62064C5.63016 3 6.6201 3 8.6 3H11.4C13.3799 3 14.3698 3 14.9849 3.62064C15.6 4.24127 15.6 5.24017 15.6 7.23798V14.652C15.6 15.7102 15.6 16.2393 15.2766 16.4475C14.7482 16.7879 13.9313 16.0742 13.5204 15.8151C13.1809 15.601 13.0112 15.4939 12.8227 15.4878C12.6192 15.4811 12.4464 15.5837 12.0796 15.8151L10.742 16.6587C10.3812 16.8862 10.2008 17 10 17C9.79924 17 9.61885 16.8862 9.258 16.6587L7.92039 15.8151C7.58091 15.601 7.41117 15.4939 7.22278 15.4878C7.01921 15.4811 6.84646 15.5837 6.47962 15.8151C6.06877 16.0742 5.25182 16.7879 4.72337 16.4475C4.40001 16.2393 4.40001 15.7102 4.40001 14.652Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 9.30078H7.2",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 6.5H7.2",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptActIc);
export default __webpack_public_path__ + "static/media/recept_act_ic.38611921327a66a31df7de4b501b6ccb.svg";
export { ForwardRef as ReactComponent };